module.exports = __webpack_public_path__ + "img/35_13.ec804ea3.png";